/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EventType = {
	OnNext: 'OnNext',
	OnSkip: 'OnSkip',
} as const;
export type EventType = (typeof EventType)[keyof typeof EventType];

export function instanceOfEventType(value: any): boolean {
	for (const key in EventType) {
		if (Object.prototype.hasOwnProperty.call(EventType, key)) {
			if (EventType[key as keyof typeof EventType] === value) {
				return true;
			}
		}
	}
	return false;
}

export function EventTypeFromJSON(json: any): EventType {
	return EventTypeFromJSONTyped(json, false);
}

export function EventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventType {
	return json as EventType;
}

export function EventTypeToJSON(value?: EventType | null): any {
	return value as any;
}

export function EventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): EventType {
	return value as EventType;
}
